window.B2BUtils = window.B2BUtils || {};

window.B2BUtils.calculateEspressoTotalKg = function (items) {
  if (!window.B2B?.espressoIasi?.enabled) return 0;

  let totalKg = 0;

  items.forEach(item => {
    const grams = item.grams;
    const quantity = item.quantity;

    if (!grams || grams <= window.B2B.espressoIasi.minGrams) return;

    totalKg += (grams * quantity) / 1000;
  });

  return totalKg;
};
